<template>
  <v-container>
    <v-row class="mx-0" v-show="etapa<=1">
      <v-col cols="12">
        <h1 class="mb-2">Condição de edição</h1>
        <p>
            Quais guias deseja alterar? <br />
            Informar campos e condições para localizar as guias ou itens que
            serão alterados.
        </p>
      </v-col>
      <v-col class="pa-0" cols="12">
        <v-form ref="condicoesForm" :value="formValid" :disabled="disableFilterEdicaoMassa">
          <v-row class="ma-0">
            <v-col class="px-3 py-0">
            <v-radio-group v-model="tipo_consulta" row small @change="filterCamposList(tipo_consulta)">
                <v-radio
                v-if="tipoGuiaId!='3' && tipoGuiaId!='5'"
                  label="Guias"
                  value="guias"
                ></v-radio>
                <v-radio
                  label="Itens"
                  value="itens"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="ma-0" v-for="(item, ind) in condicoes" :key="ind">
            <v-col class="px-3 py-0" cols="12" sm="6" md="3">
              <legend>Campo</legend>
              <v-select
              v-model="item.nome_campo"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              label="Selecione"
              :items="camposListEditavel"
              item-text="descricao_campo"
              item-value="nome_campo"
              outlined
              :disabled="tipo_consulta==null || tipo_consulta==''"
              @change="changeField(item,'condicoesForm')"
              :rules="formRules.required"
              class="elevation-0"
              ></v-select>
            </v-col>
            <v-col class="px-3 py-0" cols="12" sm="6" md="2">
              <legend>Comparação</legend>
              <v-select
              label="Selecione"
              v-model="item.operacao"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              :items="filteredList(item.tipo)"
              item-text="descricao"
              item-value="operador"
              outlined
              :disabled="tipo_consulta==null || tipo_consulta==''"
              :rules="formRules.required"
              ></v-select>
            </v-col>
            <!-- <v-col class="px-3 py-0" cols="12" sm="9" md="5"  v-show="item.tipo == 'Float' && item.operacao != 'IN' && item.operacao != 'NOT IN'">
              <legend>Valor de referência</legend>
              <v-text-field
                v-model="item.valor_float"
                placeholder="Valor a ser comparado"
                hint="Preencha com apenas um valor."
                persistent-hint
                v-money="money"
                outlined
                dense
                @blur="item.valor = parsePrice(item.valor_float)"
                :rules="(item.tipo == 'Float' && item.operacao != 'IN' && item.operacao != 'NOT IN')?[formRules.requiredField, formRules.typeNumber, formRules.notZero]: []"
              ></v-text-field>
            </v-col> -->
            <!-- <v-col  v-show="!(item.tipo == 'Float' && item.operacao != 'IN' && item.operacao != 'NOT IN')" class="px-3 py-0" cols="12" sm="9" md="5"> -->
            <v-col class="px-3 py-0" cols="12" sm="9" md="5">
              <legend>Valor de referência</legend>
              <v-text-field v-if="item.tipo == 'float' && item.operacao != 'IN' && item.operacao != 'NOT IN'"
                v-model="item.valor"
                placeholder="Valor a ser comparado"
                hint="Preencha com apenas um valor."
                persistent-hint
                outlined
                dense
                @input="formatPrice(item)"
                @blur="formatPrice(item)"
                :rules="[formRules.requiredField, formRules.typeNumber, formRules.notZero]"
              ></v-text-field>
              <v-text-field v-if="item.nome_campo == null  || item.tipo == 'string'"
                v-model="item.valor"
                placeholder="Valor a ser comparado"
                single-line
                :hint="item.operacao== 'IN' || item.operacao== 'NOT IN'? 'Para comparar mais de um valor, separe-os por ponto e vírgula(;)' : 'Preencha com apenas um valor.'"
                persistent-hint
                outlined
                dense
                :disabled="item.nome_campo == null "
                :rules="[formRules.requiredField]"
              ></v-text-field>
                <v-text-field  v-if="item.tipo == 'integer' || (item.tipo == 'float' && (item.operacao == 'IN' || item.operacao== 'NOT IN'))"
                v-model="item.valor"
                placeholder="Valor a ser comparado"
                :hint="item.operacao== 'IN' || item.operacao== 'NOT IN'? 'Para comparar mais de um valor, separe-os por ponto e vírgula(;)' : 'Preencha com apenas um valor.'"
                persistent-hint
                single-line
                outlined
                @input="formatPriceList(item)"
                @blur="formatPriceList(item)"
                dense
                :rules="[formRules.requiredField, formRules[(item.operacao == 'IN' || item.operacao== 'NOT IN')?'typeNumberList':'typeNumber']]"
              ></v-text-field>
              <v-text-field v-if="item.tipo == 'time'"
                v-model="item.valor"
                placeholder="HH:mm:ss"
                single-line
                outlined
                dense
                @input="formatHour(item)"
                @blur="formatHour(item)"
                maxlength="8"
                :rules="[formRules.requiredField, formRules.typeHourBR]"
              ></v-text-field>
              <v-select v-if="item.tipo == 'dominio'"
                v-model="item.valor"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                label="Selecione"
                :items="getSelectList(item.nome_campo)"
                item-text="descricao"
                item-value="valor"
                outlined
                :rules="formRules.required"
              ></v-select>
              <v-menu v-if="item.tipo == 'date'"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.data_formatada"
                    placeholder="Data a ser comparada"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                    dense
                    outlined
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    :rules="[formRules.requiredField, formRules.typeDateFormated]"
                    v-on="on"
                    @blur="item.valor = parseDate(item.data_formatada)"
                    class="datepicker"
                  ></v-text-field>
                </template>
                <v-date-picker color="primary" 
                  v-model="item.valor"
                  no-title
                  @input="item.data_formatada = formatDate(item.valor)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="px-3 pr-5 pt-5 pb-0" cols="12" sm="3" md="2">
              <!-- <v-btn
                v-if="ind < condicoes.length - 1"
                fab
                x-small
                light
                :ripple="false"
                color="grey lighten-3"
                class="elevation-0 mr-2"
                style="cursor:default"
              >
                <b class="black--text" style="font-size:14px">E</b>
        </v-btn> -->
              <!-- <v-select
              v-if="ind < condicoes.length - 1"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              label="Selecione"
              :items="operadoresLogicos"
              item-text="descricao"
              item-value="operador"
              outlined
              style="max-width: 100px; display: inline-block;"
              :rules="formRules.required"
              ></v-select> -->
              <v-btn v-if="condicoes.length > 1" small icon @click="deleteItem(ind, 'condicoes')" :disabled="disableFilterEdicaoMassa">
                <v-icon small color="red">fa-trash-alt</v-icon>
              </v-btn>
              <v-btn small v-if="ind == condicoes.length -1" icon @click="enableFilterEdicaoMassa();addItemForm('condicoes')">
              <v-icon
                color="primary"
                size="20px"
                >fa-plus</v-icon
              >
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <!-- <v-row class="ma-0" v-for="(item, ind) in condicoes" :key="ind"> -->
        <v-col class="px-3 py-0" cols="12" >
          <EdicaoTable
                v-if="filteredGuiasList.length > 0"
                :etapaType="etapa"
                :list="filteredGuiasList"
                :tipoConsulta="tipo_consulta"
                :dominiosList="dominiosList"
            />
          <h3 class="text-left error--text" v-if="emptyAnswer">Não há {{tipo_consulta}} selecionados para alteração!</h3>
          <p class="text-left" v-if="emptyAnswer">Refaça as condições antes de continuar.</p>
        </v-col>
      <!-- </v-row> -->
      <v-col class="text-left pb-0 pt-1 px-3" cols="6">
        <v-btn
          outlined
          height="30px"
          small
          color="primary"
          depressed
          @click="disableFilterEdicaoMassa? enableFilterEdicaoMassa() : goBack()"
        >{{disableFilterEdicaoMassa? 'Refazer condição' : 'voltar'}}</v-btn>
      </v-col>
        <v-col class="text-right pb-0 pt-1 px-1" cols="5">
          <v-btn 
            v-if="!disableFilterEdicaoMassa"
            height="30px"
            small
            color="primary"
            depressed
            @click="getFilteredList({tipo_consulta, condicoes})"
          >Continuar</v-btn>
          <v-btn
            v-else
            height="30px"
            small
            color="primary"
            depressed
            @click="etapas(2)"
          >Continuar para alteração</v-btn>
        </v-col>
    </v-row>
    <v-row class="ma-0" v-show="etapa == 2">
      <v-col class="px-3 py-0" cols="12">
        <h1 class="mb-2">Objeto de alteração</h1>
        <p>
          O que deseja alterar? Informar campos e condições que serão
          alteradas nas guias ou itens <br />
          que cumpram as condições selecionadas no passo anterior.
        </p>
      </v-col>
      <v-col class="pa-0" cols="12">
        <v-form ref="mudancasForm" :value="formValid">
          <v-row class="ma-0" v-for="(campo_editavel, ind) in mudancas" :key="ind">
            <v-col class="px-3 py-0" cols="12" sm="6" md="3">
              <legend>Campo</legend>
              <v-select
                v-model="campo_editavel.nome_campo"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                label="Selecione"
                :items="camposListEditavel"
                item-text="descricao_campo"
                item-value="nome_campo"
                outlined
                @change="changeField(campo_editavel,'mudancasForm', ind)"
                @blur="changeField(campo_editavel,'mudancasForm', ind)"
                :rules="formRules.required"
              ></v-select>
            </v-col>
            <v-col class="px-3 py-0" cols="12" sm="9" md="5">
              <legend>Novo valor do campo</legend>
              <v-text-field v-if="campo_editavel.tipo == 'float'"
                v-model="campo_editavel.valor"
                placeholder=""
                persistent-hint
                outlined
                dense
                @input="formatPrice(campo_editavel)"
                @blur="formatPrice(campo_editavel)"
                :rules="[formRules.requiredField, formRules.typeNumber, formRules.notZero]"
              ></v-text-field>
              <v-text-field v-if="campo_editavel.nome_campo == null || campo_editavel.tipo == 'string'"
                v-model="campo_editavel.valor"
                placeholder=""
                single-line
                outlined
                dense
                :disabled="campo_editavel.nome_campo == null "
                :rules="[formRules.requiredField]"
              ></v-text-field>
                <v-text-field v-if="campo_editavel.tipo=='integer'"
                v-model="campo_editavel.valor"
                placeholder=""
                single-line
                outlined
                dense
                :rules="[formRules.requiredField, formRules.typeNumber, formRules.notZero]"
              ></v-text-field>
              <v-text-field v-if="campo_editavel.tipo == 'time'"
                v-model="campo_editavel.valor"
                placeholder="HH:mm:ss"
                single-line
                outlined
                dense
                @input="formatHour(campo_editavel)"
                @blur="formatHour(campo_editavel)"
                maxlength="8"
                :rules="[formRules.requiredField, formRules.typeHourBR]"
              ></v-text-field>
              <v-select v-if="campo_editavel.tipo == 'dominio'"
                v-model="campo_editavel.valor"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                label="Selecione"
                :items="getSelectList(campo_editavel.nome_campo)"
                item-text="descricao"
                item-value="valor"
                outlined
                :rules="formRules.required"
              ></v-select>
              <v-menu v-if="campo_editavel.tipo == 'date'"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="campo_editavel.data_formatada"
                    placeholder="Nova data"
                    format="DD/MM/YYYY"
                    v-mask="'##/##/####'"
                    dense
                    outlined
                    append-icon="mdi-calendar"
                    v-bind="attrs"
                    :rules="[formRules.requiredField, formRules.typeDateFormated]"
                    v-on="on"
                    @blur="campo_editavel.valor = parseDate(campo_editavel.data_formatada)"
                    class="datepicker"
                  ></v-text-field>
                </template>
                <v-date-picker color="primary" 
                  v-model="campo_editavel.valor"
                  no-title
                  @input="campo_editavel.data_formatada = formatDate(campo_editavel.valor)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="px-0 py-0 text-right" cols="12" sm="3" md="4">
                <v-spacer></v-spacer>
                <v-btn v-if="mudancas.length > 1" small icon @click="deleteItem(ind, 'mudancas')" >
                  <v-icon small color="red">fa-trash-alt</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn small v-if="ind == mudancas.length-1" icon @click="addItemForm('mudancas')">
                <v-icon color="primary" size="20px">fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col class="text-left pb-0 pt-1 px-3" cols="6">
        <v-btn
          outlined
          height="30px"
          small
          color="primary"
          depressed
          @click="etapas(1)"
        >voltar</v-btn>
      </v-col>
      <v-col class="text-left pb-0 pt-1 px-1" cols="6">
        <v-btn
          height="30px"
          small
          color="primary"
          depressed
          @click="effectEdit(tipo_consulta, condicoes, mudancas)"
        >Efetuar a edição</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
const condicaoInicial = { nome_campo: null, operacao: null, valor: null }
const mudancaInicial = { nome_campo: null, valor: null }
import { mapState } from "vuex";
import EdicaoTable from "@/components/faturamento/detalhes_lote/EdicaoTable.vue";
export default {
  components:{
    EdicaoTable
  },
  data() {
    return {
      tipo_consulta: null,
      emptyAnswer: false,
      camposListEditavel:[],
      disableFilterEdicaoMassa: false,
      filteredCamposList: [],
      filteredGuiasList: [],
      etapa: 1,
      operadoresLogicos:[
        { operador: 'AND', descricao:'E' },
        { operador: 'OR', descricao:'OU' },
      ],
      operadores: [
        { operador: 'IN', descricao:'é igual a', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
        { operador: 'NOT IN', descricao:' é diferente de ', tipos: ['string', 'integer', 'float', 'dominio', 'date', 'time'] },
        { operador: '>', descricao:'é maior que', tipos: ['integer', 'float', 'date', 'time'] },
        { operador: '<', descricao:'é menor que', tipos: ['integer', 'float', 'date', 'time'] },
        { operador: 'like', descricao:'contém', tipos: ['string'] }],
      condicoes: [ { ...condicaoInicial}],
      mudancas: [ { ...mudancaInicial}],
      position: null,
      position2: null,
      formValid: true,
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    etapaType(num) {
      if (num == 0) {
        this.resetForms()
        this.etapa = num
      } else {
        if(this.$refs.mudancasForm){
          this.$refs.mudancasForm.resetValidation()
        }
        this.etapa = num
      }
    },
    camposList: {
      deep: true,
      handler(val){
        this.camposListEditavel = val.filter(campo => campo.is_editavel)
        this.filterCamposList(this.tipo_consulta) 
      }
    }
  },
  mounted() {
      this.tipo_consulta = this.tipoGuiaId==3 ? 'itens' : 'guias'
      this.filterCamposList(this.tipo_consulta)
  },
  beforeUnmount() {
    this.tipo_consulta=null
    this.enableFilterEdicaoMassa()
    this.condicoes = [ { ...condicaoInicial}]
    this.mudancas = [ { ...mudancaInicial}]
  },
  methods: {
    enableFilterEdicaoMassa(){
      this.emptyAnswer=false
      this.disableFilterEdicaoMassa=false
      this.filteredGuiasList=[]
    },
    goBack(){
      this.showClose()
      this.resetForms()
    },
    filteredList(tipoDoCampo){
      if(!tipoDoCampo){
        return []
      }
      return this.operadores.filter(el => el.tipos.includes(tipoDoCampo))
    },
    filterCamposList(val) {
      if(!val) {
        return
      }
      this.condicoes = [{ nome_campo: null, operacao: null, valor: null }]
      this.emptyAnswer = false
      if(this.$refs.condicoesForm){
        this.$refs.condicoesForm.resetValidation()
      }
      if(val=='guias' && this.camposList){
       this.camposListEditavel = this.camposList.filter(campo => campo.is_editavel && (campo.nome_campo == "->'profissionalExecutante'->>'CBOS'" || campo.nome_campo == "->'profissionalSolicitante'->>'CBOS'"))
      } else if(this.camposList){
       this.camposListEditavel = this.camposList.filter(campo => campo.is_editavel && campo.nome_campo != "->'profissionalExecutante'->>'CBOS'" && campo.nome_campo != "->'profissionalSolicitante'->>'CBOS'")
      }
    },
    getCampoObj(nome_campo){
      return this.camposList.find(el => el.nome_campo == nome_campo)
    },
    changeField(item, form, ind) {
      if(item.nome_campo==null){
        this.$refs[form].validate()
        return
      }
      if(form=='mudancasForm' && this.mudancas && this.mudancas.filter(el=> el.nome_campo == item.nome_campo).length > 1){
        this.mudancas[ind] = { ...mudancaInicial}
        let paramModal = {
            type: "warning",
            title: "Atenção!",
            message: "Já existe alteração para o campo selecionado.",
            callback: () => { 
              this.mudancas[ind] = { ...mudancaInicial};
              this.$nextTick(()=>this.$refs[form].validate())
              
              },
            btConfirm: { name: "Ok", show: true },
            btCancel: { name: "Cancel", show: false },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        return
      }
      this.enableFilterEdicaoMassa()
      item.valor = null
      item.data_formatada = null
      let campoObj = this.getCampoObj(item.nome_campo)
      item.tipo = campoObj.tipo
      if(form && this.$refs[form]) {
        this.$refs[form].resetValidation()
      }
    },
    compareTipo(nome_campo, tipo) {
      let campoObj = this.getCampoObj(nome_campo)
      return  campoObj? tipo == campoObj.tipo : false
    },
    getSelectList(nome_campo){
      let ind = this.getListIndex(nome_campo)
      return ind!=null? this.dominiosList[ind].valores : []
    },
    getListName(nome_campo){
      let campoObj = this.getCampoObj(nome_campo)
      return  campoObj!=undefined? campoObj.nome_dominio : null
    },
    getListIndex(nome_campo){
      let nome_dominio = this.getCampoObj(nome_campo)? this.getCampoObj(nome_campo).nome_dominio : null
      let index = nome_dominio? this.dominiosList.findIndex(el => el.dominio == nome_dominio) : null
      return  index
    },
    etapas(val) {
      if (val == 2 && this.$refs.condicoesForm.validate()) {
          this.etapa = val
          this.sendEtapa(val)
      } else if (val == 3 && this.$refs.mudancasForm.validate()) {
          this.sendEtapa(val)
      } else {
          this.sendEtapa(val)
      }
    },
    addItemForm(listName) {
      let formName = listName+'Form'
      if (this.$refs[formName].validate()) {
        let nome_campo, valor, 
        opts = { nome_campo, valor }
        if(listName=='condicoes'){opts.operacao = null}
        this[listName].push(opts)
      }
    },
    deleteItem(ind, nomeDaLista) {
      if(this[nomeDaLista].length > 1) {
        this[nomeDaLista].splice(ind,1)
      }
    },
    effectEdit(tipo_consulta, condicoes, mudancas) {
      if (this.$refs.mudancasForm.validate()){
        this.sendEtapa(3, {tipo_consulta, condicoes, mudancas})
      }
    },
    resetForms(){
      this.condicoes.splice(1, this.condicoes.length)
      this.mudancas.splice(1, this.mudancas.length)
      this.$refs.condicoesForm.reset()
      this.$refs.mudancasForm.reset()
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatPrice(item) {
      let value = item.valor.replaceAll(/(!\d|\.|,)/g, '')
      value = value.toString().replace(/\B(?=(\d{2})(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      item.valor = value
    },
    formatPriceList(item){      
      if (item.tipo == 'float'){
        let list = item.valor.replaceAll(' ', '').replaceAll(/;{2,}/g,';').split(';').filter(el=> !!el)
        list = list.map(value=> value.replaceAll(/(!\d|\.|,)/g, '').toString().replace(/\B(?=(\d{2})(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
        item.valor=list.join('; ')
      }
    },
    formatHour(item) {
      if(item.valor.length>8) {
        item.valor = (item.valor).substr(0, 8)
        return
      }
      let value = item.valor.replace(/(!\d|\.|,|:)/g, '')
      value = value.toString().replace(/\B(?=(\d{2})+(?!\d|:)){8}/g, ":")
      item.valor = value
    },
    getFilteredList(formData){
      if(this.$refs.condicoesForm.validate()){
      formData.lote_id = this.$route.params.id
      formData.tipo_consulta = this.tipo_consulta
      let obj = {
        query: [
          {
            Modulo: "Faturamento",
            Acao: "getguiasedicaomassa",
            Payload: {
              grupo_economico: this.grupoEconomico,
              ...formData
            },
          },
        ],
      };
      this.$store.dispatch('request/doRequest', obj).then(resp=>{
        this.filteredGuiasList = resp && resp.dados? resp.dados : []
        this.disableFilterEdicaoMassa = this.filteredGuiasList.length? true : false
        this.emptyAnswer = !this.filteredGuiasList.length? true : false
      })
      }
    }
  },
  props: {
    camposList: Array,
    dominiosList: Array,
    sendEtapa: Function,
    showClose: Function,
    etapaType: Number,
    grupoEconomico: Number,
    tipoGuiaId: String
  }
}
</script>
